<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" />
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue